export default __webpack_public_path__ + "static/media/small.725f6b57.svg";